import React from 'react';
import ReactView from "shared/react_view";
import NavTabs from './../components/NavTabs';
/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class NavTabsView extends ReactView {
  constructor(syncStatus, disabled, onNavigate, onDeactivate) {
    super(<NavTabs
      syncStatus={syncStatus}
      disabled={disabled}
      onClick={onNavigate}
      onDeactivate={onDeactivate}
    />);
  }
}
